module.exports = __webpack_public_path__ + "img/map.3901c075.svg";